<ion-header class="generic-modal__header">
  <ion-toolbar>
    <ion-buttons slot="end">
      <button class="generic-modal__close-button" type="button" (click)="dismiss()" aria-label="Close">
        <ion-icon class="icon icon-CLOSE" />
      </button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-card class="generic-modal__card">
    <app-card-header-title-subtitle [icon]="modalData.icon" [title]="modalData.title"
      [subtitle]="modalData.subtitle ?? ''">
    </app-card-header-title-subtitle>

    <ion-card-content class="p-0">
      <ion-item-divider></ion-item-divider>
      <ion-row class="generic-modal__buttons" [class.generic-modal__buttons--single]="!!!modalData.leftButton">
        @if(modalData.leftButton) {
          <ion-col size="12" sizeLg="6">
            <ion-button class="generic-modal__button" fill="outline" (click)="_btnCancel()">
              {{ modalData.leftButton.label | translate}}
            </ion-button>
          </ion-col>
        }
        @if(modalData.rigthButton) {
          <ion-col size="12" [sizeLg]="!!modalData.leftButton ? 6 : 12" [class.generic-modal__single-button-column]="!!!modalData.leftButton">
            <ion-button #button (click)="_btnCont()" class="generic-modal__button button-solid" expand="block" [class.ion-float-right]="!!modalData.leftButton">
              {{ modalData.rigthButton.label | translate }}
            </ion-button>
          </ion-col>
        }
      </ion-row>
    </ion-card-content>
  </ion-card>
</ion-content>
